type ItemType = 'ITEM' | 'PRODUCT'

const labelColors = {
  ITEM: 'bg-blue-500',
  PRODUCT: 'bg-fleamarket',
} as const

type Props = {
  displayPrice: string
  type?: ItemType | undefined
}

/**
 * @deprecated 値札の縦幅がページごとに変わってしまうので、PriceLabelコンポーネントを使用してください
 */
export const ItemDisplayPrice: React.FC<Props> = ({
  displayPrice,
  type = 'ITEM',
}) => (
  <span
    className={`inline-block rounded-[2px] bg-blue-500 px-[6px] py-[2px] leading-[1.2] text-white ${labelColors[type]} xl:px-2 xl:py-[3px] xl:tracking-[0.03em]`}
  >
    {displayPrice}
  </span>
)
